// https://github.com/lucas-issa/simple-react-dropzone
import React from 'react';
import { ReduxFormFieldSimpleReactDropzone } from 'simple-react-dropzone';

import './filepicker.css';
import './dropzone.css';

const DropzoneField = props => {
  const handlerDownload = (file) => {
    document.location.href = '/' + window.lang + '/api/shop-files/' + file.id + '/';
  }

  // @todo проверка разрешений файла
  return <ReduxFormFieldSimpleReactDropzone
    // By default will be used to upload (POST method), download (GET method) and delete (DELETE method).
    uploadUrl={'/' + window.lang + '/api/shop-files/'}
    downloadUrl={ handlerDownload }
    imediateRemove={ false } // Choose the mode you want to use. Look at props documentation.
    maxFilesize={ 20 } // MB
    maxFiles={ 10 }
    dragAndClickMessage={ gettext('Перетащите сюда файлы или кликните для их выбора.') }
    {...props}
  />
};

export default DropzoneField;